import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

// Verifica si el usuario ya resolvió (respondió o cerró) un disparador de NPS
// identificado por triggerKey. Persiste en DB (no localStorage) para que "no
// volver a preguntar" sea consistente entre dispositivos/navegadores.
export function useNpsPromptDismissed(triggerKey: string | null) {
  const { profile } = useAuth();
  return useQuery({
    queryKey: ['nps-prompt-dismissed', profile?.id, triggerKey],
    queryFn: async () => {
      const { data } = await supabase
        .from('nps_prompt_dismissals')
        .select('id')
        .eq('user_id', profile!.id)
        .eq('trigger_key', triggerKey!)
        .maybeSingle();
      return !!data;
    },
    enabled: !!profile?.id && !!triggerKey,
  });
}

// Resuelve un disparador de NPS: si viene `score`, guarda la respuesta real en
// nps_responses; en todos los casos marca el trigger como resuelto en
// nps_prompt_dismissals para no volver a mostrarlo.
export async function resolveNpsPrompt(params: {
  userId: string;
  triggerKey: string;
  cohortId: string | null;
  score?: number | null;
  comment?: string | null;
}) {
  const { userId, triggerKey, cohortId, score, comment } = params;
  if (score !== null && score !== undefined) {
    const { error } = await supabase.from('nps_responses').insert({
      user_id: userId,
      score,
      comment: comment?.trim() || null,
      cohort_id: cohortId,
    });
    if (error) throw error;
  }
  const { error: dismissError } = await supabase
    .from('nps_prompt_dismissals')
    .upsert({ user_id: userId, trigger_key: triggerKey }, { onConflict: 'user_id,trigger_key' });
  if (dismissError) throw dismissError;
}
